import React, {useState} from 'react';
import ImageCarousel from '@components/ImageCarousel/ImageCarousel';
import _ from "lodash-es";
import {numberToWord} from "@src/helpers";

const getFileNameFromUrl = (url) => {
    let fileName = url.substring(url.lastIndexOf("/") + 1);
    let prefix = fileName.substring(0, fileName.indexOf("_"));
    let newFileName;

    if (prefix === "thumbnail" || prefix === "large" || prefix === "medium") {
        newFileName = "large_" + fileName.substring(fileName.indexOf("_") + 1); // replace prefix with "large_"
    } else {
        newFileName = fileName;
    }

    return newFileName;
}


const formatBigImage = (img: any) => {
    let idx = img.lastIndexOf("/");
    let host = img.slice(0, idx + 1);
    let name = getFileNameFromUrl(img)

    let isNewType = (/thumbnail_|large_|medium_/).test(img);
    if (isNewType) {
        return `${host + name}`;
    } else {
        return img;
    }
}

const StepMedia = ({medias, name = ''}: any) => {
    const [isOpenModal, setOpenModal] = useState(false);
    const [initSlide, setInitSlide] = useState(0);
    const imagesCarousel = medias.imgCarousel.filter((img: string) => img).map((img: string) => formatBigImage(img));

    const outsideClickListener = (event: any) => {
        const classList = Object.values(event.target.classList);
        const isClickOut = classList.find((item: any) => item === 'picture-modal-box');
        if (isClickOut) {
            handleCloseModal();
        }
    }

    const pressESCListener = (event: any) => {
        if (event.keyCode === 27) {
            handleCloseModal();
        }
    }

    const handleClickImage = (img: number) => {
        setOpenModal(true);
        setInitSlide(img);
        document.documentElement.classList.add('modal-open');
        document.addEventListener('click', outsideClickListener);
        document.addEventListener('keyup', pressESCListener);
    }


    const handleCloseModal = () => {
        setOpenModal(false);
        document.documentElement.classList.remove('modal-open');
        document.removeEventListener('click', outsideClickListener);
        document.removeEventListener('keyup', pressESCListener);
    }

    return (
        <>
            {imagesCarousel.length > 0 && isOpenModal &&
                <>
                    <div className="modal-backdrop fade show"></div>
                    <div className="modal fade picture-modal-box show">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{name}</h5>
                                    <button type="button" className="close" onClick={handleCloseModal}>&times;</button>
                                </div>
                                <div className="modal-body">
                                    <ImageCarousel imgList={imagesCarousel} imgCur={initSlide}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }


            <div className="gallery">
                <div className="row">

                    <div className={`col-12 col-md-4  order-2 `}>
                        <div className="gallery-img">

                            {imagesCarousel.length > 0 && <div className="gallery-img-item">
                                {
                                    _.map(imagesCarousel, (img: any, index: number) => {
                                        return (
                                            <span key={index}
                                                  className={`gallery-img-item__${numberToWord(index + 1)}`}
                                                  style={{backgroundImage: `url(${medias.imgCarousel[index]})`}}
                                                  onClick={() => handleClickImage(index)}>
                                            </span>
                                        )
                                    })
                                }
                            </div>}

                        </div>
                    </div>

                    <div className="col-12 col-md-8 gallery-video order-1">
                        {medias.video && medias.video.search("undefined") === -1 &&
                            <div className="embed-responsive embed-responsive-16by9">
                                <video width="100%" controls>
                                    <source src={medias.video} type="video/mp4"/>
                                </video>
                            </div>
                        }
                    </div>

                </div>
            </div>

        </>
    );
}

export default StepMedia;
